export const round = (value = 0, decimals = 0) =>
  Math.round(value * 10 ** decimals) / 10 ** decimals || null;

export const percent2 = (value = 0, decimals = 0) => `${round(value, decimals)}%`;

export const percent = (value = 0) => {
  value = parseFloat(value)
  return `${value.toFixed(1)}%`
}

export const inRange = (value = 0, min, max) => {
  const lt = max ? value < max : true;
  const gt = min ? value >= min : true;

  return lt && gt;
};

export const formatNumber = (number = 0) => number.toLocaleString('en-US');
